import React from 'react'
import { Button, Card, Dropdown, Menu } from 'antd'
import {
  BarChartOutlined,
  DribbbleSquareOutlined,
  GoldOutlined,
  InfoCircleOutlined,
  LineChartOutlined,
  PieChartOutlined,
  TableOutlined
} from '@ant-design/icons'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ChartTypes = [
  {
    name: 'table',
    title: 'Table',
    icon: <TableOutlined />
  },
  {
    name: 'number',
    title: 'Number',
    icon: <InfoCircleOutlined />
  },
  {
    name: 'chord',
    title: 'Chord Diagram',
    icon: <DribbbleSquareOutlined />
  },
  {
    name: 'bar',
    title: 'Bar Chart',
    icon: <BarChartOutlined />
  },
  {
    name: 'pie',
    title: 'Pie Chart',
    icon: <PieChartOutlined />
  },
  {
    name: 'line',
    title: 'Line',
    icon: <LineChartOutlined />
  },
  {
    name: 'occupancymap',
    title: 'Occupancy',
    icon: <GoldOutlined />
  }
]

interface ISelectChartType {
  availableChartNames?
  chartType
  updateChartType
}

const SelectChartType = (props: ISelectChartType) => {
  const { t } = useTranslation()

  const { availableChartNames, chartType, updateChartType } = props

  const availableCharts = availableChartNames
    ? ChartTypes.filter((item) => {
        return availableChartNames.includes(item.name)
      })
    : ChartTypes
  let foundChartType = availableCharts.find((t) => t.name === chartType)
  if (!foundChartType) {
    foundChartType = availableCharts[0]
  }

  return availableCharts.length > 1 ? (
    <Card title={t('solutions.scenes.overview.add.output')}>
      <Dropdown
        overlay={
          <Menu>
            {availableCharts.map((chart) => (
              <Menu.Item
                key={chart.name}
                icon={chart.icon}
                onClick={() => updateChartType(chart.name)}
              >
                {chart.title}
              </Menu.Item>
            ))}
          </Menu>
        }
        placement="bottomLeft"
        trigger={['click']}
      >
        <Button icon={foundChartType.icon}>{foundChartType.title}</Button>
      </Dropdown>
    </Card>
  ) : (
    <></>
  )
}

SelectChartType.propTypes = {
  chartType: PropTypes.string.isRequired,
  updateChartType: PropTypes.func.isRequired
}

export default SelectChartType
